import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { LinkBtnComponent } from '@enginuity/core/molecules/tertiary/link-btn.component';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  imports: [CommonModule, CeIconComponent, LinkBtnComponent],
})
export class InfoComponent {
  @Input()
  label = 'This is an example of a not important notification.';

  @Input()
  Type = 'grey';

  @Input() Icons = 'warning_info';

  @Input()
  icon = true;

  @Input()
  closeAlert = false;

  @Input()
  middle = false;

  @Input()
  close = true;

  @Input()
  show_button = false;

  @Input()
  Size: 'large' | 'medium' = 'large';

  closealert() {
    this.closeAlert = true;
  }
}
